(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7923],{

/***/ 36810:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vara/[slug]",
      function () {
        return __webpack_require__(96644);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProductPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30844);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40324);
/* harmony import */ var _byko_lib_algolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5283);
/* harmony import */ var _byko_component_breadcrumbs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5644);
/* harmony import */ var _byko_lib_api_dato_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42039);
/* harmony import */ var _byko_lib_api_rest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97639);
/* harmony import */ var _byko_scene_byko_product_page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62115);
/* harmony import */ var _byko_scene_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4651);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91987);
/* harmony import */ var _byko_lib_api_products__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68825);
/* harmony import */ var _byko_lib_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65582);
/* harmony import */ var _byko_component_product_card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64549);
/* harmony import */ var src_features_search_components_product_list__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63839);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43285);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_14__);
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ 














ProductPage.getInitialProps = async (ctx)=>{
    const slug = ctx.query["slug"];
    let product;
    try {
        const { data  } = await _byko_lib_api_rest__WEBPACK_IMPORTED_MODULE_6__/* .restApi.productsBySlugRetrieve */ ._O.productsBySlugRetrieve(slug);
        product = data;
    } catch (e) {
        const error = e;
        if (error && error.status === 404) {
            return {
                errorCode: 404
            };
        }
        ctx.res && (ctx.res.statusCode = 500);
        return {
            errorCode: 500
        };
    }
    if (!product) {
        ctx.res && (ctx.res.statusCode = 404);
        return {
            errorCode: 404
        };
    }
    var ref;
    // FIXME: Shouldn't we at least report this error?
    const cmsPage = (ref = await (0,_byko_lib_api_dato_client__WEBPACK_IMPORTED_MODULE_5__/* .getProductPageBySlug */ .v7)()(slug).catch((e)=>console.error(e))) !== null && ref !== void 0 ? ref : undefined;
    const catRefMap = (0,_features__WEBPACK_IMPORTED_MODULE_2__/* .buildCategoryReferenceMap */ .y2)(ctx.categories);
    const breadCrumbs = (0,_features__WEBPACK_IMPORTED_MODULE_2__/* .dropProductBreadCrumbs */ .tP)(catRefMap, product);
    return {
        product,
        cmsPage,
        breadCrumbs
    };
};
function ProductPage(param) {
    let { //
    errorCode , product , cmsPage , breadCrumbs  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14;
    const { data  } = (0,_byko_lib_algolia__WEBPACK_IMPORTED_MODULE_3__/* .useAlgoliaProductQuery */ .zC)({
        productIds: (ref14 = product === null || product === void 0 ? void 0 : product.idealAccessories) !== null && ref14 !== void 0 ? ref14 : null
    });
    const pricedProducts = data === null || data === void 0 ? void 0 : (ref = data.hits) === null || ref === void 0 ? void 0 : ref.filter((p)=>!(p.salesAvailability === "custom" || p.salesAvailability === "display" || (0,src_features_search_components_product_list__WEBPACK_IMPORTED_MODULE_13__/* .isRentalProduct */ .o)(p))).map((p)=>p.id);
    const { prices  } = (0,_byko_lib_api_products__WEBPACK_IMPORTED_MODULE_10__/* .useProductLowestPrices */ .BY)(pricedProducts !== null && pricedProducts !== void 0 ? pricedProducts : []);
    const prods = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_11__/* .ensureList */ .fL)(data === null || data === void 0 ? void 0 : data.hits.map(_byko_lib_api_products__WEBPACK_IMPORTED_MODULE_10__/* .algoliaHitToProduct */ .Qo));
    const collection = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(()=>{
        const productCards = prods.map((relatedProduct, index)=>{
            if ((0,src_features_search_components_product_list__WEBPACK_IMPORTED_MODULE_13__/* .isRentalProduct */ .o)(relatedProduct)) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_12__/* .ProductRentCard */ .iJ, {
                    addedLabel: "Leiguvara",
                    listIndex: index,
                    product: relatedProduct,
                    smallMobileCard: true
                }, relatedProduct.id);
            } else {
                var ref;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_12__/* .ProductStandardCard */ .ZL, {
                    analyticsSectionId: "related-product-slider",
                    listIndex: index,
                    lowestPriceSKU: (prices === null || prices === void 0 ? void 0 : prices[relatedProduct.id]) !== undefined ? Object.keys((ref = prices === null || prices === void 0 ? void 0 : prices[relatedProduct.id]) !== null && ref !== void 0 ? ref : {})[0] : undefined,
                    prices: prices === null || prices === void 0 ? void 0 : prices[relatedProduct.id],
                    product: relatedProduct,
                    smallMobileCard: true
                }, relatedProduct.id);
            }
        });
        return productCards;
    }, [
        prices,
        prods
    ]);
    let defaultVariant;
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(()=>{
        if ((0,src_features_search_components_product_list__WEBPACK_IMPORTED_MODULE_13__/* .isRentalProduct */ .o)(product)) {
            window.location.replace("/leiguvara/".concat(product.slug));
        }
    }, [
        product
    ]);
    if ((0,src_features_search_components_product_list__WEBPACK_IMPORTED_MODULE_13__/* .isRentalProduct */ .o)(product)) {
        return null;
    }
    if (product == null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_error__WEBPACK_IMPORTED_MODULE_8__/* .ErrorScene */ ._, {
            code: 404
        });
    }
    try {
        // prettier-ignore
        defaultVariant = (product === null || product === void 0 ? void 0 : product.defaultVariant) == null ? product.variants[0] : product.variants.find((v)=>product.defaultVariant === v.id);
        if (errorCode || defaultVariant == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_error__WEBPACK_IMPORTED_MODULE_8__/* .ErrorScene */ ._, {
                code: errorCode
            });
        }
    } catch (e) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_error__WEBPACK_IMPORTED_MODULE_8__/* .ErrorScene */ ._, {
            code: 404
        });
    }
    const additionalProducts = {
        productSliderSectionHeading: "Tengdar v\xf6rur",
        productSliderSectionCollection: collection,
        productSliderSectionParagraph: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    };
    var ref15, ref16, ref17, ref18, ref19, ref20, _sku, ref21, _packagingQuantity;
    const seoProductGroupSchema = {
        "@context": "https://schema.org",
        "@type": "ProductGroup",
        description: (ref1 = product.description) === null || ref1 === void 0 ? void 0 : ref1.is,
        name: product.name,
        productGroupID: (ref2 = product.attributes) === null || ref2 === void 0 ? void 0 : ref2["groupId"],
        category: (ref15 = (ref4 = (ref3 = product.attributes) === null || ref3 === void 0 ? void 0 : ref3["typeParent"]) === null || ref4 === void 0 ? void 0 : ref4.map((t)=>t["is-IS"])) !== null && ref15 !== void 0 ? ref15 : "",
        brand: (ref16 = (ref5 = product.attributes) === null || ref5 === void 0 ? void 0 : ref5["brand"]) !== null && ref16 !== void 0 ? ref16 : "",
        image: (ref17 = (ref6 = product.media) === null || ref6 === void 0 ? void 0 : ref6.map((m)=>{
            var ref;
            return (ref = m.image) === null || ref === void 0 ? void 0 : ref.productList;
        })) !== null && ref17 !== void 0 ? ref17 : "",
        hasEnergyConsumptionDetails: (ref18 = (ref8 = (ref7 = product.attributes) === null || ref7 === void 0 ? void 0 : ref7["energyTag"]) === null || ref8 === void 0 ? void 0 : ref8["is-IS"]) !== null && ref18 !== void 0 ? ref18 : "",
        hasCertification: (ref19 = (ref10 = (ref9 = product.attributes) === null || ref9 === void 0 ? void 0 : ref9["environmentalInfoType"]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11["is-IS"]) !== null && ref19 !== void 0 ? ref19 : "",
        keywords: (ref20 = (ref13 = (ref12 = product.attributes) === null || ref12 === void 0 ? void 0 : ref12["seo"]) === null || ref13 === void 0 ? void 0 : ref13["is-IS"]) !== null && ref20 !== void 0 ? ref20 : "",
        hasVariant: product.variants.map((v)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            return {
                "@type": "Product",
                name: v.name || product.name,
                sku: (_sku = v.sku) !== null && _sku !== void 0 ? _sku : "",
                color: (ref = v.meta) === null || ref === void 0 ? void 0 : ref.color,
                image: (ref21 = ((ref1 = v.firstImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.productList) || ((ref3 = product.firstImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.productList)) !== null && ref21 !== void 0 ? ref21 : "",
                description: (ref5 = product.description) === null || ref5 === void 0 ? void 0 : ref5.is,
                inProductGroupWithID: (ref6 = product.attributes) === null || ref6 === void 0 ? void 0 : ref6["groupId"],
                productID: "ean:".concat((ref7 = v.attributes) === null || ref7 === void 0 ? void 0 : ref7["eanNumber"]),
                weight: (ref8 = v.attributes) === null || ref8 === void 0 ? void 0 : ref8["weight"],
                hasMeasurement: {
                    "@type": "QuantitativeValue",
                    unitText: (ref9 = v.meta) === null || ref9 === void 0 ? void 0 : ref9.unit,
                    value: (_packagingQuantity = v.packagingQuantity) !== null && _packagingQuantity !== void 0 ? _packagingQuantity : ""
                },
                size: (ref10 = v.meta) === null || ref10 === void 0 ? void 0 : ref10.size,
                offers: {
                    "@type": "Offer",
                    price: (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_11__/* .formatPriceNumber */ .Sg)((ref11 = v.price) === null || ref11 === void 0 ? void 0 : ref11.gross),
                    priceCurrency: (ref12 = v.price) === null || ref12 === void 0 ? void 0 : ref12.currency,
                    availability: v.inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                    url: "https://byko.is/vara/".concat(product.slug)
                }
            };
        })
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_14___default()), {
                id: "product-metadata",
                type: "application/ld+json",
                children: JSON.stringify(seoProductGroupSchema)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                    children: [
                        "BYKO - ",
                        product.name
                    ]
                })
            }, "product-page"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_breadcrumbs__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumbs */ .O, {
                breadcrumbs: breadCrumbs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features__WEBPACK_IMPORTED_MODULE_2__/* .ProductPageContent */ .Yr, {
                additionalProducts: collection.length ? additionalProducts : undefined,
                defaultVariant: defaultVariant,
                product: product,
                rental: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_byko_product_page__WEBPACK_IMPORTED_MODULE_7__/* .BykoProductPage */ .n, {
                page: cmsPage
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [194,7780,6497,9774,2888,179], function() { return __webpack_exec__(36810); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);